module.exports = __webpack_public_path__ + "img/animals_lion.e89bec8a.png";